import Styles from "./index.module.scss";
import clsx from "clsx";

export const LoginInput = ({
  name,
  error,
  label,
  value,
  type = "text",
  isRequired = false,
  placeholder = "",
  onChange,
  isDisable = false,
}) => {
  return (
    <div className={clsx(Styles.wrap)}>
      <div className={clsx(Styles.inputBox)}>
        <input
          name={name}
          id={name}
          value={value}
          onChange={onChange}
          className={clsx(Styles.input)}
          type={type}
          required={isRequired}
          placeholder={placeholder}
          disabled={isDisable}
        />
        <label className={clsx(Styles.label)} htmlFor={name}>
          {label}
        </label>
      </div>
      {error && <span className={clsx(Styles.error)}>{error.message}</span>}
    </div>
  );
};
